import useNavigator from "@dashboard/hooks/useNavigator";
import { newsletterListUrl } from "@dashboard/newsletter/urls";
import { Box, Button } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { customerFormsMessages as m } from "./messages";
import { feedbackListUrl, productAlertsListUrl } from "./urls";

export type CustomerFormsTab = "newsletter" | "feedback" | "productAlerts";

const tabs = [
  { id: "newsletter", label: m.tabNewsletter, url: () => newsletterListUrl() },
  { id: "feedback", label: m.tabFeedback, url: feedbackListUrl },
  { id: "productAlerts", label: m.tabProductAlerts, url: productAlertsListUrl },
] as const;

/** Tab bar shared by the Newsletter, Feedback and Product alerts pages. */
export const CustomerFormsTabs = ({ active }: { active: CustomerFormsTab }) => {
  const intl = useIntl();
  const navigate = useNavigator();

  return (
    <Box display="flex" gap={2} flexWrap="wrap" paddingX={6} paddingBottom={4} role="tablist">
      {tabs.map(tab => (
        <Button
          key={tab.id}
          role="tab"
          aria-selected={tab.id === active}
          variant={tab.id === active ? "primary" : "secondary"}
          onClick={() => tab.id !== active && navigate(tab.url())}
          data-test-id={`customer-forms-tab-${tab.id}`}
        >
          {intl.formatMessage(tab.label)}
        </Button>
      ))}
    </Box>
  );
};
